<template>
  <div>
    <nav :class="{ collapse: isCollapsed }" class="bd-links">
      <div v-for="n of nav" :key="n.root" class="bd-toc-item" :class="{ active: n.isActive }" @click="isActive(n)">
        <a class="bd-toc-link" href="#"> {{ n.root }} </a>
        <ul class="nav bd-sidenav">
          <li v-for="p of n.pages" :key="p.name" :class="{ active: p.url === '/' + activeItem }">
            <a :href="p.url" v-if="this.isAllowed(p.url)">
              <i v-if="this.isAllowed(p.url)" :class="p.icon"></i>
              <span v-if="this.isAllowed(p.url)">{{ p.name }} </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="bd-toc-item active">
        <ul class="nav bd-sidenav">
          <li>
            <a href="#" @click="privacy">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>
      <div class="bd-toc-item active">
        <ul class="nav bd-sidenav">
          <li>
            <a href="#" @click="logout">
              Logout
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { auth } from '@/stores'
export default {
  name: 'nav-left',
  data() {
    return {
      searchText: '',
      isCollapsed: true,
      activeItem: null,
      nav: [
        {
          root: '',
          isActive: true,
          pages: [
            { url: '/', name: 'Home' },
            { url: '/locations', name: 'Locations' },
            // { url: '/users', name: 'Users' },
            { url: '/storage', name: 'Storage' },
            // { url: '/contacts', name: 'Contacts' },
            { url: '/insurance', name: 'Insurance' },
            { url: '/fleet', name: 'Fleet' },
            { url: '/testdrives', name: 'Test Drive ROs' },
            // { url: '/configuration', name: 'Configuration' }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapState(auth, ['isAllowed'])
  },
  methods: {
    ...mapActions(auth, ['clearToken']),
    isActive() {
      return true
    },
    isVisible(pages) {
      return pages.some((p) => this.isAllowed(p.url))
    },
    search() {
      this.isCollapsed = false
      for (let n of this.nav) {
        n.isHidden = false
        let count = 0
        for (let p of n.pages) {
          p.isHidden = !p.name
            .toLowerCase()
            .includes(this.searchText.toLowerCase())
          if (!p.isHidden) {
            count++
          }
        }
        n.isHidden = !count
      }
      this.$forceUpdate()
    },
    logout() {
      this.clearToken()
      window.location.assign('/')
    },
    privacy() {
      window.open(
        'https://www.testdrivecopilot.com/pages/privacy-policy',
        '_blank'
      )
    }
  },
  mounted() {
    let url = window.location.href
    this.activeItem = url.substring(url.lastIndexOf('/') + 1)
  }
}
</script>
